<template>
  <section
    class="invoice-preview-wrapper"
    style="position: relative"
  >
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="order === undefined"
    >
      <h4 class="alert-heading">
        Erreur lors du chargement de l'échange
      </h4>
      <div class="alert-body">
        Aucun échange trouvé avec cette référence. Vérifiez
        <b-link
          class="alert-link"
          :to="{ name: 'echange-order' }"
        >
          la recherche d'échange
        </b-link>
        pour d'autres références.
      </div>
    </b-alert>

    <!-- Loading state -->
    <div
      v-if="order === null"
      class="text-center py-5"
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Chargement...</span>
      </div>
      <p class="mt-2 text-muted">
        Vérification de l'échange en cours...
      </p>
    </div>

    <b-row
      v-if="order"
      class="invoice-preview"
    >
      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          v-if="order"
          no-body
          class="invoice-preview-card"
        >

          <div
            class="d-flex justify-content-between flex-wrap mr-1 ml-1"
          >

            <div class="invoice-preview">
              <strong
                class="mt-1"
                style="color: #0A2634; font-size: 40px"
              >
                Colis Echange

              </strong>
              <h3 style="color: black ">
                Echange :
                <span
                  class="invoice-date"
                  style="color: black"
                >
                  {{ currentDateTime() }}</span>
              </h3>
              <h3 style="color: black ">
                Date:
                <span
                  class="invoice-date"
                  style="color: black"
                >
                  {{ formatFn(order.created_at) }}</span>
              </h3>
              <div class="d-flex justify-content-between mt-1">
                <div>
                  <qrcode-vue
                    :value="(order.cross_tenant_barcode || order.id).toString()"
                    :size="size"
                    level="H"
                  />
                  <span>{{ order.id }}</span>

                </div>
                <div>
                  <barcode
                    height="30"
                    width="2"
                    :value="(order.cross_tenant_barcode || order.id).toString()"
                  />
                </div>

              </div>

            </div>

            <div style="text-align:end">
              <div>
                <img
                  src="@/assets/images/logo/logo.png"
                  width="250px"
                  height="100%"
                >

              </div>
              <div class="mt-1">
                <b-card-text
                  class="h4"
                  style="color: black"
                >
                  <strong
                    style="color:#0A2634"
                  >{{ company.name }} :</strong> {{ company.tagline || 'Société de livraison des colis' }}
                </b-card-text>
                <b-card-text
                  class="h4"
                  style="color: black"
                >
                  <strong
                    style="color:#0A2634"
                  >Matricule fiscale :</strong> {{ company.tax_identification_number }}
                </b-card-text>
                <b-card-text
                  class="h4"
                  style="color: black"
                >
                  <strong
                    style="color:#0A2634"
                  >Adresse :</strong> {{ company.address }}
                </b-card-text>
                <b-card-text
                  class="h4"
                  style="color: black"
                >
                  <strong
                    style="color:#0A2634"
                  >Tel :</strong> {{ company.phone1 }}
                </b-card-text>

              </div>

            </div>
          </div>

          <!-- Exchange Status Indicator -->
          <b-card-text
            v-if="order.is_an_exchange === true"
            class="h4 ml-1 text-center p-1"
            style="color:black;font-size: 25px; border:1px solid black; background-color: #ffffff;"
          >
            <strong style="color:#0A2634">Échange</strong>
          </b-card-text>

          <!-- Non-Exchange Status Indicator -->
          <b-card-text
            v-if="order.is_an_exchange !== true"
            class="h4 ml-1 text-center p-1"
            style="color:black;font-size: 25px; border:1px solid #dc3545; background-color: #ffffff;"
          >
            <strong style="color:#dc3545">Colis Standard (Non Échange)</strong>
          </b-card-text>

          <div class="d-flex flex-row justify-content-between mr-1 ml-1 mb-1">

            <div>

              <div
                style="border: 2px solid black;font-size: 18px;"
              >
                <b-card-text class="ml-2 mr-2 mt-2 mb-1 font-weight-bold">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Client : </span> {{ order.name }}
                </b-card-text>
                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Gouvernorat : </span>{{ order.governorate.name }} <span v-if="order.delegation != null"> {{ order.delegation.name }}</span>
                </b-card-text>

                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Adresse :</span>
                  {{ order.address }}
                </b-card-text>
                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  > téléphone :</span>
                  {{ order.phone1 }} / {{ order.phone2 }}
                </b-card-text>
              </div>
            </div>
            <div>

              <div
                class="ml-2"
                style="border: 2px solid black;font-size: 18px;"
              >

                <b-card-text class="ml-2 mr-2 mt-2 mb-1 font-weight-bold">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Fournisseur :</span> {{ order.supplier.username }}
                </b-card-text>
                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Téléphone : </span>{{ order.supplier.phone }}
                </b-card-text>
                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  >Adresse :</span>
                  {{ order.supplier.address }}
                </b-card-text>
                <b-card-text class="ml-2 mr-2 mb-1">
                  <span
                    style="font-weight:900; color: #0A2634"
                  > Matricule Fiscale :</span>
                  {{ order.supplier.tax_identification_number }}
                </b-card-text>
              </div>
            </div>

          </div>

          <!-- Invoice Description: Table -->
          <div class="mr-1 ml-1">
            <b-table-lite
              class="ta"
              style="font-size: 20px; border: 2px solid black"
              responsive
              :items="p"
              :fields="['désignation', 'quantité']"
            >
              <template #cell(taskDescription)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.taskTitle }}
                </b-card-text>
                <b-card-text class="text-nowrap">
                  {{ data.item.taskDescription }}
                </b-card-text>
              </template>
            </b-table-lite>
          </div>
          <!-- Invoice Description: Total -->
          <div class="mr-1 ml-1">
            <b-row>
              <b-col>
                <h1
                  style="color: #0A2634; font-size: 18px ; font-weight: bold"
                >
                  Commentaire :
                  <span
                    style="font-size: 15px ; color:black;"
                  >
                    {{ order.note }}
                  </span>
                </h1>
                <div>

                  <b-card-text
                    v-if="order.is_fragile ==true"
                    class="h4"
                    style="color:black"
                  >
                    <strong style="color:#0A2634">Fragile :</strong> OUI
                  </b-card-text>
                  <b-card-text
                    v-if="order.is_discharge == true"
                    class="h4"
                    style="color:black"
                  >
                    <strong style="color:#0A2634">Décharge :</strong> OUI
                  </b-card-text>
                </div>

              </b-col>
              <b-col
                class="ml-2"
                style="font-size: 20px"
              >
                <table
                  style="border: 2px solid #0A2634"
                >
                  <tr class="badge-glow bg-info bg-lighten-5">
                    <th class="text-center">
                      Montant HT: {{ order.price_ht }}
                    </th>
                  </tr>
                  <tr class="badge-glow bg-primary bg-lighten-5"><th class="text-center">TVA 7 %: {{ order.tax }}
                  </th></tr>
                  <tr class="badge-glow bg-success bg-lighten-1"> <th class="text-center">Total TTC: {{ order.price_ttc }} DT
                  </th></tr>

                </table>
              </b-col>

            </b-row>
          </div>

        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>
          <!-- Exchange Status Alert -->
          <b-alert
            v-if="!order.is_an_exchange"
            variant="warning"
            show
            class="mb-2"
          >
            <h6 class="alert-heading">
              <feather-icon
                icon="AlertTriangleIcon"
                size="16"
                class="mr-1"
              />
              Non échangeable
            </h6>
            <div class="alert-body">
              Ce colis n'est pas un échange. L'impression n'est pas disponible.
            </div>
          </b-alert>

          <!-- Exchange Success Alert -->
          <b-alert
            v-if="order.is_an_exchange"
            variant="success"
            show
            class="mb-2"
          >
            <h6 class="alert-heading">
              <feather-icon
                icon="CheckCircleIcon"
                size="16"
                class="mr-1"
              />
              Colis d'échange
            </h6>
            <div class="alert-body">
              Ce colis est un échange valide.
            </div>
          </b-alert>

          <!-- Button: Print (only for exchanges) -->
          <b-button
            v-if="order.is_an_exchange"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(order)"
          >
            <feather-icon
              icon="PrinterIcon"
              size="16"
              class="mr-1"
            />
            Imprimer échange
          </b-button>

          <!-- Disabled Print Button (for non-exchanges) -->
          <b-button
            v-if="!order.is_an_exchange"
            variant="outline-secondary"
            class="mb-75"
            block
            disabled
          >
            <feather-icon
              icon="XCircleIcon"
              size="16"
              class="mr-1"
            />
            Impression non disponible
          </b-button>

          <!-- Button: Back to search -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            block
            :to="{ name: 'echange-order' }"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="16"
              class="mr-1"
            />
            Retour à la recherche
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from 'bootstrap-vue'
import VueBarcode from 'vue-barcode'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import storeAuth from '@/store/store'
import QrcodeVue from 'qrcode.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    barcode: VueBarcode,
    QrcodeVue,
  },
  data() {
    return {
      size: 80,
      p: [],
      order: null, // Start with null to show loading state
      company: {},
    }
  },

  created() {
    this.id = this.$route.params.id
    this.company = storeAuth.state.company
    this.getOrder()
  },
  methods: {
    currentDateTime() {
      const current = new Date()
      const date = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`
      const time = `${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`
      const dateTime = `${date} | ${time}`

      return dateTime
    },
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      const h = date.slice(11, 19)
      return `${year}-${month.padStart(2, '0')}-${day1.padStart(
        2,
        '0',
      )} | ${h}`
    },
    formatDate(date) {
      if (!date) {
        return null
      }
      const [year] = date.split('-')
      return `${year.slice(2, 4)}`
    },
    parseDate(date) {
      if (!date) {
        return null
      }
      const [month, day, year] = date.split('/')
      return `${year.padStart(0, '0')}-${month.padStart(2, '0')}-${day.padStart(
        2,
        '0',
      )}`
    },
    addnewitem(qte, nom) {
      this.p.push({
        désignation: nom,
        quantité: qte,
      })
    },
    async getOrder() {
      try {
        const paramId = this.$route.params.id
        const endpoint = Number.isNaN(Number(paramId)) ? `/api/orders/detail-by-ref/${paramId}` : `/api/orders/detail/${paramId}`
        const response = await axios.get(endpoint)
        const orderData = response.data // Check if the order exists
        if (!orderData) {
          this.showToast('danger', 'Erreur', 'Aucune commande trouvée avec cette référence.')
          this.$router.push({ name: 'echange-order' })
          return
        }

        // Check if the order is an exchange
        if (!orderData.is_an_exchange) {
          this.showToast('warning', 'Accès refusé', 'Cette commande n\'est pas un échange. Seuls les échanges peuvent être consultés ici.')
          this.$router.push({ name: 'echange-order' })
          return
        }

        // If we get here, it's a valid exchange order
        this.order = orderData

        // Add products to the list for printing
        if (this.order && this.order.products) {
          for (let i = 0; i < this.order.products.length; i += 1) {
            this.addnewitem(this.order.products[i].quantity, this.order.products[i].product)
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching order:', error)

        if (error.response?.status === 404) {
          this.showToast('danger', 'Erreur', 'Commande non trouvée.')
        } else if (error.response?.status === 403) {
          this.showToast('danger', 'Accès refusé', 'Vous n\'avez pas l\'autorisation de consulter cette commande.')
        } else {
          this.showToast('danger', 'Erreur', 'Une erreur est survenue lors du chargement de la commande.')
        }

        // Redirect back to exchange search page
        this.$router.push({ name: 'echange-order' })
      }
    },

    showToast(variant, title, text) {
      let icon = 'AlertCircleIcon'
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else if (variant === 'warning') {
        icon = 'AlertTriangleIcon'
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          text,
          variant,
        },
      }, {
        position: 'top-right',
        timeout: 5000,
      })
    },
  },
  setup() {
    const printInvoice = order => {
      // Only print if the order is an exchange
      if (order && order.is_an_exchange) {
        window.print()
      } else {
        // eslint-disable-next-line no-console
        console.warn('Cannot print: Order is not an exchange')
        // You could also show a toast notification here
      }
    }

    return {
      printInvoice,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
table,
td,
th {
  padding: 10px;
  text-align: left;
  border: 1px solid #0A2634;
}

table {
  width: 100%;
  border-collapse: collapse;
}
.mycolor {
  background-color: #EA2F2F;
}
.contact {
  background-color: #EA2F2F;
  padding: 10px;
  border-radius: 20px;
}
</style>

<style lang="scss">
@media print {
.ta {
    white-space: nowrap;
    overflow-x: visible;
    font-size: 22px;
    color: black;
  }
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto; /* Footer height */
  }

  .table thead th {
    border-bottom: 2px solid black;
  }

  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  .mycolor {
    background-color: #EA2F2F;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .contact {
    background-color: #EA2F2F;
    padding: 20px;
    border-radius: 25px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  footer footer-light footer-static {
    display: inline-block;
  }
  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  table,
  td,
  th {
    padding: 10px;
    text-align: left;
    border: 1px solid black;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
}
</style>
